import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useHistory } from 'react-router-dom';

function Callback() {
  const auth = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (auth.isAuthenticated) {
      history.replace('/');
    }
  }, [auth.isAuthenticated, history]);

  if (auth.isLoading) {
    return <div>Loading authentication...</div>;
  }

  if (auth.error) {
    return <div>Authentication error: {auth.error.message}</div>;
  }

  return <div>Finishing login...</div>;
}

export { Callback };
